import React, { useState, useEffect } from 'react';
import { handleSSORedirect } from 'services/zendesk/handleSSORedirect';
import './style.css';

const HelpBar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isMac, setIsMac] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkIfMac = () => {
      if (navigator.userAgentData && navigator.userAgentData.platform) {
        return navigator.userAgentData.platform.toUpperCase().includes('MAC');
      }
      return navigator.userAgent.toUpperCase().includes('MAC');
    };

    setIsMac(checkIfMac());

    const handleKey = (e) => {
      if ((isMac && e.metaKey && e.key.toLowerCase() === 'i') || (!isMac && e.ctrlKey && e.key.toLowerCase() === 'i')) {
        e.preventDefault();
        setIsModalOpen(true);
      }
      if (e.key === 'Escape') setIsModalOpen(false);
    };

    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isMac]);

  const searchArticles = async (q) => {
    if (!q.trim()) {
      setResults([]);
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `https://agrare.zendesk.com/api/v2/help_center/articles/search.json?query=${encodeURIComponent(q)}`
      );
      const data = await response.json();
      setResults(data.results || []);
    } catch (err) {
      console.error('Erro ao buscar artigos:', err);
    } finally {
      setLoading(false);
    }
  };

  const fixedSuggestions = [
    { title: 'Guia inicial da plataforma', url: 'https://agrare.zendesk.com/hc/articles/123456' },
    { title: 'Melhores práticas', url: 'https://agrare.zendesk.com/hc/articles/234567' },
    { title: 'Central de vídeos', url: 'https://agrare.zendesk.com/hc/categories/345678' },
  ];

  return (
    <>
      {/* Botão que abre a modal */}
      <div
        className="helpbar-button"
        onClick={() => setIsModalOpen(true)}
      >
        <i className="mdi mdi-magnify helpbar-icon"></i>
        <span className="helpbar-text">Me Ajude...</span>
        <div className="helpbar-shortcut">{isMac ? '⌘ + I' : 'Ctrl + I'}</div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="helpbar-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="helpbar-modal" onClick={(e) => e.stopPropagation()}>
            
            {/* Cabeçalho */}
            <div className="helpbar-header">
              <h2>Central de Ajuda</h2>
              <button className="helpbar-close" onClick={() => setIsModalOpen(false)}>×</button>
            </div>

            {/* Campo de busca */}
            <div className="helpbar-search">
              <i className="mdi mdi-magnify helpbar-search-icon"></i>
              <input
                type="text"
                placeholder="Buscar artigos ou tutoriais..."
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                  searchArticles(e.target.value);
                }}
              />
            </div>

            {/* Loader */}
            {loading && (
              <div className="helpbar-loader">
                <i className="mdi mdi-loading mdi-spin"></i>
              </div>
            )}

            {/* Sugestões fixas */}
            {/* {!loading && !query && (
              <div className="helpbar-suggestions">
                <strong>Sugestões úteis</strong>
                {fixedSuggestions.map((item, idx) => (
                  <div
                    key={idx}
                    className="helpbar-suggestion-item"
                    onClick={() => handleSSORedirect({ articleItem: { url: item.url } })}
                  >
                    {item.title}
                  </div>
                ))}
              </div>
            )} */}

            {/* Resultados */}
            {!loading && query && (
              <div className="helpbar-results">
                {results.map(article => (
                  <div
                    key={article.id}
                    className="helpbar-result-item"
                    onClick={() => handleSSORedirect({ articleItem: { url: article.html_url } })}
                  >
                    {article.title}
                  </div>
                ))}
                {results.length === 0 && !loading && (
                  <div className="helpbar-no-results">Nenhum resultado encontrado.</div>
                )}
              </div>
            )}

            {/* Rodapé */}
            {!loading && (
              <div className="helpbar-footer">
                <span>Não encontrou o que procura?</span>
                <button
                  className="helpbar-ticket-button"
                  onClick={() => window.zE && window.zE('messenger', 'open')}
                >
                  Abrir um ticket de suporte
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default HelpBar;
